import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, CircularProgress, Grid,  } from '@mui/material';
import {
  TrendingUp as TrendingIcon,
  Receipt as InvoiceIcon,
  People as PeopleIcon,
  CheckCircle as PaidIcon,
} from '@mui/icons-material';
import client from '../../api/client';

const formatNumber = (num) => {
  return new Intl.NumberFormat('fa-IR').format(num || 0);
};

const StatCard = ({ title, value, subtitle, icon, color }) => (
  <Card>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Box
          sx={{
            p: 1.5,
            borderRadius: 2,
            bgcolor: `${color}.light`,
            color: `${color}.main`,
            ml: 2,
          }}
        >
          {icon}
        </Box>
        <Typography variant="body2" color="text.secondary">
          {title}
        </Typography>
      </Box>
      <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
        {value}
      </Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </CardContent>
  </Card>
);

const SalesStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await client.get('/users/dashboard/');
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
        آمار فروش
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <StatCard
            title="فروش کل"
            value={formatNumber(stats?.total_sales)}
            subtitle="ریال"
            icon={<TrendingIcon />}
            color="success"
          />
        </Grid>

        <Grid item xs={6}>
          <StatCard
            title="تعداد فاکتورها"
            value={formatNumber(stats?.invoices_count)}
            icon={<InvoiceIcon />}
            color="primary"
          />
        </Grid>

        <Grid item xs={6}>
          <StatCard
            title="تعداد مشتریان"
            value={formatNumber(stats?.customers_count)}
            icon={<PeopleIcon />}
            color="info"
          />
        </Grid>

        <Grid item xs={12}>
          <StatCard
            title="محصولات فعال"
            value={formatNumber(stats?.products_count)}
            icon={<PaidIcon />}
            color="warning"
          />
        </Grid>
      </Grid>

      {/* Recent Activity */}
      {stats?.recent_invoices?.length > 0 && (
        <Card sx={{ mt: 3 }}>
          <CardContent>
            <Typography variant="h6" sx={{ mb: 2 }}>
              آخرین فعالیت‌ها
            </Typography>
            {stats.recent_invoices.map((invoice) => (
              <Box
                key={invoice.id}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  py: 1.5,
                  borderBottom: '1px solid',
                  borderColor: 'divider',
                }}
              >
                <Box>
                  <Typography variant="body2" fontWeight="bold">
                    فاکتور {invoice.invoice_number}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {invoice.customer_name || 'بدون مشتری'} • {invoice.invoice_date}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  color={invoice.status === 'Paid' ? 'success.main' : 'text.primary'}
                >
                  {formatNumber(invoice.final_amount)} ریال
                </Typography>
              </Box>
            ))}
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default SalesStats;
